<script setup lang="ts">
import type { CmsElementSmallTextBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementSmallTextBox;
  class: any;
  style: any;
}>();

const { heading, subHeading, image } = props.content?.config

const { category } = useCategory();

</script>

<template>
  <section class="section section--solid section-category-teaser" :style="props.style" :class="props.class">
    <div class="container">
      <div class="section__body">
        <div class="section__content">

          <h2>
            <NuxtImg v-if="image.value" :src="image.value.url" height="30" class="me-2" :alt="category.translated.name"/>
            <span v-if="heading.value">{{ heading.value }}</span>
            <span v-else>{{ category.translated.name }}</span>
          </h2>
          <p>{{ subHeading.value }}</p>
        </div><!-- /.section__content -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>